// extracted by mini-css-extract-plugin
export default {"head":"core_head__KkJ2U","subhead":"core_subhead__IutXP","cardHead":"core_cardHead__qgHjv","cardText":"core_cardText__jHvtQ","adserveCard":"core_adserveCard__XY5Me"};